<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-people-group" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="t-title">{{ registration.conferences.title }}</div>
            <div class="meta"><i class="fas fa-people-group fa-fw mr-2"></i>{{registration.conf_reg_types ? registration.conf_reg_types.title : null}}</div>

            <section v-if="registration.reg_applications && registration.reg_applications.length" class="mb-1">
                <hr class="mt-2 mb-1"/>
                <div v-for="app in registration.reg_applications">
                    <div class="columns is-gapless">
                        <div class="column is-narrow meta"><i class="fas fa-fw mr-2" :class="{'fa-check': app.completed_at, 'fa-exclamation-triangle': !app.completed_at}"></i></div>
                        <div class="column meta">{{ app.conf_applications.applications.title }}</div>
                    </div>
                </div>
            </section>

        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat"><i class="fas fa-fw" :class="{'fa-check': !registration.is_po_pending, 'fa-exclamation-triangle': registration.is_po_pending}"></i></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="tile-details">
                <div class="data mt-1">
<!--                    <data-row mini title="Type">{{registration.conf_reg_types.title}}</data-row>-->
                    <data-row mini title="Date">{{registration.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
<!--                    <data-row mini title="Confirmation">{{ registration.code }}</data-row>-->
<!--                    <data-row mini title="Payment">-->
<!--                        <span v-if="registration.payment_type === 'cc'">{{registration.total_paid | currency}} by Credit Card</span>-->
<!--                        <span v-if="registration.payment_type === 'po'">{{registration.total_paid | currency}} by Purchase Order</span>-->
<!--                    </data-row>-->
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'UserRegistrationTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            registration: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {};
        },
        methods: {
            openCard: function (card, props) {
                this.$openCard(card, props, this.card);
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .t-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.5rem;
        }

        .fa-exclamation-triangle {
            color: #e28c07;
        }

        .fa-check {
            color: green;
        }
    }
</style>
